module.exports = __webpack_public_path__ + "img/cpp.9f2c619a.jpg";